// Página do produto: escolher a cor troca a galeria, o preço, o prazo e o id do carrinho; miniaturas trocam a foto.
(() => {
  const raiz = document.querySelector('[data-cz-produto]');
  if (!raiz) return;
  const id = raiz.querySelector('[data-cz-id]');
  const preco = raiz.querySelector('[data-cz-preco]');
  const prazo = raiz.querySelector('[data-cz-prazo]');
  const nome = raiz.querySelector('[data-cz-cor-nome]');
  const botoes = raiz.querySelectorAll('.cz-pp__botoes .cz-botao');
  raiz.querySelectorAll('.cz-pp__cor').forEach((b) => b.addEventListener('click', () => {
    raiz.querySelectorAll('.cz-pp__cor').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    const v = b.dataset.variante;
    if (id) id.value = v;
    if (preco) preco.textContent = b.dataset.preco;
    if (prazo) prazo.textContent = b.dataset.prazo;
    if (nome) nome.textContent = b.dataset.nome;
    const livre = b.dataset.disponivel === 'true';
    botoes.forEach((x) => { x.disabled = !livre; });
    raiz.querySelectorAll('.cz-pp__grupo').forEach((g) => { g.hidden = g.dataset.variante !== v; });
    const u = new URL(location.href); u.searchParams.set('variant', v); history.replaceState(null, '', u);
  }));
  raiz.querySelectorAll('.cz-pp__grupo').forEach((g) => {
    const foto = g.querySelector('[data-cz-foto]');
    g.querySelectorAll('.cz-pp__mini').forEach((m) => m.addEventListener('click', () => {
      g.querySelectorAll('.cz-pp__mini').forEach((x) => x.removeAttribute('aria-current'));
      m.setAttribute('aria-current', 'true');
      if (foto) { foto.removeAttribute('srcset'); foto.src = m.dataset.grande; foto.alt = m.dataset.alt; }
    }));
  });
})();
